module.exports = __webpack_public_path__ + "media/images/countryrect/mc-9bd29f6ed759e451ffe1ced857debec0.svg";